import React from "react";
import MiCompAPI from "./../../util/api";
import {

  Form,
  Row,
  Col,
  Layout,
  Select,
  message,
  Button,Icon
} from "antd";
import FileBase64 from 'react-file-base64';
const { Content } = Layout;
const { Option } = Select;
class MI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: "Load Invoice Data",
       months: [], years: [],
      filedata: null,
      lob: []
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentWillMount = () => {
    this.getClientMasters();
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            months: data.months,
            years: data.years,
            lob: data.lobs
          });
        }
      },
      [ "MTH", "YR", "LOB"]
    );
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.type === "reconcillation") {
          if (this.fileData) {
            if (this.fileData.file.size < 2097152 && this.fileData.name.split('.')[1] === 'csv') {
              this.props.submitHandler({ ...values, type: this.props.type, base64file: this.fileData.base64, docName: this.fileData.name });
            } else {
              if (this.fileData.file.size > 2097152)
              {
                message.error("File size must under 2MiB!", 3);
              }
              if (this.fileData.name.split('.')[1] !== 'csv') {
                message.error("Invalid File Format!, Please upload csv File", 3);
              }
            }
          }
        }
        else {
          this.props.submitHandler({ ...values, type: this.props.type, });
        }
      }
    });
  }
  handleAddDocument = (data) => {
    if (data.file.size > 2097152)
    {
      message.error("File size must under 2MiB!", 3);
    }
    if (data.name.split('.')[1] !== 'csv') {
      message.error("Invalid File Format!, Please upload csv File", 3);
    }
    this.fileData = data
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Content>
          <Row>
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              hideRequiredMark
            >
              <Row span={24}>

                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Year </legend>
                      {getFieldDecorator('IYear', {
                        rules: [{ required: true, message: 'Please select Year' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select Year">
                        {this.state.years.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>

                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Month</legend>
                      {getFieldDecorator('IMonth', {
                        rules: [{ required: true, message: 'Please select Month' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select Month">
                        {this.state.months.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>
                <Col md={12} sm={24}>
                  {this.props.type === "reconcillation" ?
                    <Form.Item>
                      <fieldset className="mi_input_pop">
                        <legend className="legend-font">Process Payment File</legend>
                        <FileBase64 onDone={this.handleAddDocument} />
                      </fieldset>
                    </Form.Item>
                    : ""}
                </Col>
              </Row>
              <Row span={24} style={{float:'right',marginRight:"12px"}}>
                <Col span={24}>
                  <Form.Item>
                    <Button htmlType="submit" type="primary">
                      Submit
                              </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
      </Content>
    )
  }
}
const ManageInvoiceForm = Form.create()(MI);
export default ManageInvoiceForm;